import React from 'react'

import { Field } from 'formik'

import { AdminContext } from 'contexts/AdminContext'

import { Form, Col } from '_zari/core'

import { TransaccionCuenta1242Select, TransaccionCuentaPrincipalSelect } from 'sharedComponents/select'

const ModeloCuentas12FormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  flagEditar,
  vCodigoTransaccion,
  setFieldValue
}) => {
  const __adminContext = React.useContext(AdminContext)

  const oneRowTrigger = React.useCallback(
    firstOption => {
      if (!flagEditar) {
        setFieldValue('_idModeloCuentas12', firstOption._id)
      }
    },
    [setFieldValue, flagEditar]
  )

  return (
    <Form.Group>
      <Form.Label text='CUENTA 12' htmlFor='select-modeloCuentas12' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idModeloCuentas12'>
          {({ field }) => (
            <>
              {__adminContext.valoresConfiguracionUsuario.flagCambioCuenta12 ? (
                <TransaccionCuenta1242Select
                  {...field}
                  id='select-modeloCuentas12'
                  isInvalid={iTouched && iError}
                  disabled={fIsSubmitting}
                  transaccion={vCodigoTransaccion}
                  oneRowTrigger={oneRowTrigger}
                />
              ) : (
                <TransaccionCuentaPrincipalSelect
                  {...field}
                  id='select-modeloCuentas12'
                  isInvalid={iTouched && iError}
                  disabled={fIsSubmitting}
                  transaccion={vCodigoTransaccion}
                  oneRowTrigger={oneRowTrigger}
                />
              )}
            </>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ModeloCuentas12FormGroup)
